module.exports = __webpack_public_path__ + "static/media/Logo.0721c0d1.png";